/**
 * Sentry Middleware
 */

import { errorLog } from "utils/Rave";

function crashReporter(store){
	return function(next){
		return function(action){
			try {
				return next(action);
			} catch(error) {
				errorLog({
					error,
					// TODO: Switch this out with a config.json replacement
					// We want to log the error to the console in DEV ONLY
					console: true,
					context: {
						action,
						state:  store.getState(),
					},
				});

				throw error;
			}
		};
	};
}

export default crashReporter;
